import { render, staticRenderFns } from "./btnScrollTop.vue?vue&type=template&id=1191bd8c"
import script from "./btnScrollTop.vue?vue&type=script&lang=js"
export * from "./btnScrollTop.vue?vue&type=script&lang=js"
import style0 from "./btnScrollTop.vue?vue&type=style&index=0&id=1191bd8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports